import classNames from "classnames";
import React, { useEffect, useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import useScroll from "../components/hooks/useScroll";
import sidebarRoutes from "../routes/sidebarRoutes";

function SidebarItem({ href, id, title, Icon }) {
  return (
    <NavLink to={href} className="sidebar-item">
      <div className="sidebar-item__icon-wrapper">
        <Icon className="sidebar-item__icon" />
      </div>
      <span className="sidebar-item__title">{title}</span>
    </NavLink>
  );
}

export default function () {
  const [showSidebar, setShowSidebar] = useState(true);
  const scroll = useScroll();

  const links = useMemo(() => {
    return sidebarRoutes.sort((obj1, obj2) => obj1.id - obj2.id);
  }, []);

  useEffect(() => {
    if (window.innerWidth > 991) {
      return null;
    }
    console.log(scroll.difY);
    setShowSidebar(scroll.difY > 0 ? false : true);
  }, [scroll]);

  return null;
  // <aside className={classNames("sidebar", { showed: showSidebar })}>
  //     {links.map(link => (<SidebarItem {...link} key={link.id} />))}
  // </aside>
}
